import { TOOL_CATEGORIES } from '../../modules/tools';

const Header = ({
  activeCategory,
  onCategorySelect,
  searchTerm,
  onSearchTermChange,
  darkMode,
  onToggleDarkMode,
}) => (
  <header className="border-b border-slate-200 bg-white/80 backdrop-blur dark:border-slate-800 dark:bg-slate-900/70">
    <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-4 md:flex-row md:items-center md:justify-between">
      <div className="flex flex-1 flex-col gap-3 md:flex-row md:items-center md:gap-8">
        <h1 className="text-xl font-semibold text-slate-900 dark:text-slate-100">
          Ferramentas Dev Suite
        </h1>

        <nav className="flex flex-wrap items-center gap-2 md:gap-4">
          {TOOL_CATEGORIES.map((category) => {
            const isActive = category.id === activeCategory;
            return (
              <button
                key={category.id}
                type="button"
                className={`rounded-full px-4 py-1 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-brand-primary text-white shadow'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700'
                }`}
                onClick={() => onCategorySelect(category.id)}
              >
                {category.label}
              </button>
            );
          })}
        </nav>
      </div>

      <div className="flex items-center gap-3">
        <div className="relative flex-1 md:w-64">
          <input
            type="search"
            placeholder="Buscar ferramenta..."
            value={searchTerm}
            onChange={(event) => onSearchTermChange(event.target.value)}
            className="w-full rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 shadow-sm transition focus:border-brand-primary focus:outline-none focus:ring-2 focus:ring-brand-primary/40 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
          />
        </div>

        <button
          type="button"
          onClick={onToggleDarkMode}
          className="rounded-full border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 shadow-sm transition hover:bg-slate-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700"
          aria-label={darkMode ? 'Ativar tema claro' : 'Ativar tema escuro'}
        >
          {darkMode ? 'Modo Claro' : 'Modo Escuro'}
        </button>
      </div>
    </div>
  </header>
);

export default Header;
